import { render, staticRenderFns } from "./industryRejections.vue?vue&type=template&id=49d61766"
import script from "./industryRejections.vue?vue&type=script&lang=js"
export * from "./industryRejections.vue?vue&type=script&lang=js"
import style0 from "./industryRejections.vue?vue&type=style&index=0&id=49d61766&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports